export default __webpack_public_path__ + "static/media/1420.a0c6310f.png";